import React from 'react';

import Banner from '@components/Banner';
import { BannerProps } from '@components/Banner/interface';
import useGoogleTagManager from '@hooks/useGoogleTagManager';
import useSetSelectedOrder from '@hooks/useSetSelectedOrder';
import { assembleOrderBannerGTMEvent } from '@utils/GoogleTagManager';
import { GOOGLE_TAG_MANAGER_EVENT_MESSAGES } from '@utils/GoogleTagManager/interface';

const UpdateQuoteBanner = ({
  buttons,
  message,
  status,
  order,
}: BannerProps) => {
  const { changeSelectedOrder } = useSetSelectedOrder();
  const { setGTMEvent } = useGoogleTagManager();

  const handleSelectOrder = () => {
    setGTMEvent(
      assembleOrderBannerGTMEvent(
        GOOGLE_TAG_MANAGER_EVENT_MESSAGES.UPDATE_QUOTE_BANNER,
        { ...(order?.id && { orderDetail: { orderId: order?.id } }) },
      ),
    );
    changeSelectedOrder(order?.id, order);
  };

  return (
    <Banner
      buttons={[
        {
          ...buttons[0],
          onPress: () => handleSelectOrder(),
        },
      ]}
      message={message}
      status={status}
    />
  );
};

export default UpdateQuoteBanner;
